import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
// components/
import TestView from "./testView";
// layout
import { colors } from "../layout/constants";
import Wrapper from "../layout/wrapper";
import Header from "../layout/header";
import LoadingView from "../layout/loading";
import Tawk from "../layout/tawk";
// services
import { getAttendance, startAttendance } from "../../services/test";

const Test = () => {
  const [evaluation_temporaly, setevaluation_temporaly] = useState({});
  const [results_temporaly, setResults_temporaly] = useState({});
  const [evaluation, setEvaluation] = useState({});
  const [results, setResults] = useState({});
  const [aboutTest, setAboutTest] = useState({});
  const [startedTest, setStartedTest] = useState(false);
  const [finishedTest, setFinishedTest] = useState();
  //state
  const [loading, setLoading] = useState(true);
  // Redux hooks
  const userToken = useSelector((state) => state.user.token);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  // // Redux action
  const setTest = (test) => {
    dispatch({
      type: "SET_TEST_INFO",
      payload: test,
    });
  };

  useEffect(() => {
    if (userToken) {
      //getInfo();
      getTestInit();
    }
  }, []);

  const getTestInit = async () => {
    try {
      setLoading(true);
      const testInfo = await getAttendance(userToken);
      if (!testInfo) {
        setLoading(false);
        return;
      }
      if (!testInfo.evaluation) {
        setEvaluation(testInfo);
        setLoading(false);
        return;
      }
      setevaluation_temporaly(testInfo.evaluation);
      setResults_temporaly(testInfo.results);

      if(testInfo.finished_at && testInfo.score){
        setFinishedTest(testInfo);
      }

      //if (testInfo.results)
      //if(Object.keys(testInfo.results).length !== 0)
      if(testInfo){
        setStartedTest(true);
      } else setStartedTest(false);

      setLoading(false);
      // setTest(testInfo);
    } catch (error) {
      console.error(error);
    }
  };

  const drawQuestions = () => {
    setEvaluation(evaluation_temporaly);
    setResults(results_temporaly);
  };

  const getTest = async (blob, webp) => {
    if(!startedTest){
      try {
        setLoading(true);
        const testInfo = await startAttendance(userToken, blob, webp);
        setLoading(false);
        if (!testInfo.evaluation) {
          setEvaluation(testInfo);
          return;
        }
        setStartedTest(true);
        setEvaluation(testInfo.evaluation);
        setResults(testInfo.results);
        // setTest(testInfo);
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <TestStyled>
      <Header />
      <Wrapper>
        {loading ? (
          <LoadingView message="Cargando evaluación..." />
        ) : (
          <TestView
            evaluation={evaluation}
            results={results}
            aboutTest={aboutTest}
            getTest={getTest}
            startedTest={startedTest}
            drawQuestions={drawQuestions}
            finishedTest={finishedTest}
          ></TestView>
        )}
      </Wrapper>
      <Tawk user={user} />
    </TestStyled>
  );
};

const TestStyled = styled.section`
  background-color: white;
  min-height: 100vh;
`;

export default Test;
